import Vue from 'vue';
import {formatNumber} from "./tools"
import {timeStamp} from "@/utils";
Vue.filter('genderFilter', function (value) {
	if(value === 0) return '男'
	else if(value === 1) return '女'
	else return '未知'
	
})

// Y/m/d-H:i
Vue.filter('onlyTimeFilter', function (value) {
	if (!value) return ''
	let time = new Date(value*1000)
　　let year = time.getFullYear()
　　let month = time.getMonth() + 1
　　let date = time.getDate()
　　let hours = time.getHours()
　　let minute = time.getMinutes()
　　let second = time.getSeconds()

　　if (month < 10) { month = '0' + month }
　　if (date < 10) { date = '0' + date }
　　if (hours < 10) { hours = '0' + hours }
　　if (minute < 10) { minute = '0' + minute }
　　if (second < 10) { second = '0' + second }
　　return year + '-' + month + '-' + date + ' ' + hours + ':' + minute + ':' + second
	
})

Vue.filter('dateFilter', function (value) {
	if (!value) return ''
	let time = new Date(value*1000)
　　let year = time.getFullYear()
　　let month = time.getMonth() + 1
　　let date = time.getDate()
　　let hours = time.getHours()
　　let minute = time.getMinutes()
　　let second = time.getSeconds()

　　if (month < 10) { month = '0' + month }
　　if (date < 10) { date = '0' + date }
　　if (hours < 10) { hours = '0' + hours }
　　if (minute < 10) { minute = '0' + minute }
　　if (second < 10) { second = '0' + second }
　　return year + '-' + month + '-' + date
	
})

// Y/m/d-H:i:s
Vue.filter('timeDurFilter', function (value) {
	if (!value) return ''
	let time = timeStamp("Y-m-d/H:i:s", 
		typeof value === 'number' ? (String(value).length === 13 ? value : value*1000) : Date.parse(new Date(value))
	).replace(
		"/",
		" "
	);
	return time
	
})

Vue.filter('thousandNumFilter', function (value) {
	if (!value) return '0'
	return formatNumber(value,0,1);
})



// WEBPACK FOOTER //
// ./src/utils/filter.js